import { AdsApi, AdsProps, IntegrationType } from '@accedo/one-plugin-sdk';
import { ErrorBoundary } from '@dynamic/ui';
import { createRef, Suspense, useMemo } from 'react';
import { ref } from 'valtio';

import { useAllPluginConfigs } from '#/plugins/hooks/useAllPluginConfigs';
import { getCcpaOptOutSetting } from '#/service/user/settings';
import { useBootStore } from '#/store/boot/boot.store';

import { adsActions } from '../../store/ads/ads.store';
import { pluginManager } from '../pluginManager';

export const AdsManager = () => {
  const { isPluginManagerReady } = useBootStore();

  const ads = useAllPluginConfigs(IntegrationType.VIDEO_ADS);

  const ccpaOptOut = getCcpaOptOutSetting();

  const adComponents = useMemo(() => {
    if (!ads || !isPluginManagerReady) {
      return null;
    }

    return ads.map((adConfig) => {
      const AdComponent = pluginManager.getPluginComponent<AdsProps<any, any>>({
        type: IntegrationType.VIDEO_ADS,
        id: adConfig.key,
        optional: true,
      });
      const apiRef = ref(createRef<AdsApi>());
      adsActions.addAds({
        apiRef,
        properties: adConfig.properties,
        key: adConfig.key,
      });

      return (
        <ErrorBoundary key={adConfig.key} onError={AdComponent.onError}>
          <Suspense fallback={null}>
            <AdComponent apiRef={apiRef} ccpaOptOut={ccpaOptOut} />
          </Suspense>
        </ErrorBoundary>
      );
    });
  }, [ads, ccpaOptOut, isPluginManagerReady]);

  if (!adComponents?.length) {
    return null;
  }

  return <>{adComponents}</>;
};
